"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Shimmer = _interopRequireDefault(require("../Shimmer"));

var _DiscountItem = _interopRequireDefault(require("../DiscountItem"));

var _DiscountList = _interopRequireDefault(require("./DiscountList.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable no-nested-ternary */

/* eslint-disable react/prop-types */

/* eslint-disable react/jsx-no-comment-textnodes */
// Author - Christian John B.


var DiscountListWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountList__DiscountListWrapper",
  componentId: "sc-mym6oy-0"
})(["background:", ";padding:16px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLighter;
});

var DiscountListTitle = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountList__DiscountListTitle",
  componentId: "sc-mym6oy-1"
})(["font-weight:", ";line-height:", ";font-size:", ";margin-bottom:", ";font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight.semiLarge;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.lineHeight.normal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.normal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.XXXSmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily.default;
});
DiscountListTitle.displayName = 'DiscountListTitle';

var ShimmerBoxesWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountList__ShimmerBoxesWrapper",
  componentId: "sc-mym6oy-2"
})([""]);

ShimmerBoxesWrapper.displayName = 'ShimmerBoxesWrapper';

var ShimmerBoxItem = _styledComponents.default.div.withConfig({
  displayName: "DiscountList__ShimmerBoxItem",
  componentId: "sc-mym6oy-3"
})(["border:1px solid ", ";box-sizing:border-box;box-shadow:0px 1px 2px rgba(0,0,0,0.08);border-radius:", ";height:95px;margin-bottom:", ";padding:10px 30px;.shimmer-row{margin-bottom:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyLight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.borderRadius.normal;
}, function (props) {
  return props.theme.space.XSmall;
}, function (props) {
  return props.theme.space.XSmall;
});

var NoPromoWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountList__NoPromoWrapper",
  componentId: "sc-mym6oy-4"
})(["width:100%;text-align:center;"]);

NoPromoWrapper.displayName = 'NoPromoWrapper';

var NoPromoImage = _styledComponents.default.img.withConfig({
  displayName: "DiscountList__NoPromoImage",
  componentId: "sc-mym6oy-5"
})([""]);

var NoPromoTitle = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountList__NoPromoTitle",
  componentId: "sc-mym6oy-6"
})(["text-align:center;display:block;padding:16px 0;font-weight:", ";line-height:", ";font-size:", ";font-family:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeight.semiLarge;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight.XXLarge;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSize.medium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontFamily.default;
});
NoPromoTitle.displayName = 'NoPromoTitle';
var NoPromoDescription = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountList__NoPromoDescription",
  componentId: "sc-mym6oy-7"
})(["text-align:center;display:block;font-weight:", ";line-height:", ";color:", ";font-family:", ";font-size:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontWeight.normal;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.greyDark;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontFamily.default;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontSize.normal;
});
NoPromoDescription.displayName = 'NoPromoDescription';

var DiscountItemsWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountList__DiscountItemsWrapper",
  componentId: "sc-mym6oy-8"
})([""]);

DiscountItemsWrapper.displayName = 'DiscountItemsWrapper';

var DiscountItemInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountList__DiscountItemInnerWrapper",
  componentId: "sc-mym6oy-9"
})(["padding-bottom:", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.XXXSmall;
});

var DiscountList = function DiscountList(props) {
  var theme = props.theme,
      isLoading = props.isLoading,
      data = props.data,
      translations = props.translations,
      selectedData = props.selectedData,
      onSelectDiscount = props.onSelectDiscount,
      onClickTnC = props.onClickTnC;
  var labelSelectPromo = translations.labelSelectPromo,
      labelNoPromoTitle = translations.labelNoPromoTitle,
      labelNoPromoDesc = translations.labelNoPromoDesc;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      discounts = _useState2[0],
      setDiscounts = _useState2[1];

  var _useState3 = (0, _react.useState)(isLoading),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isDiscountLoading = _useState4[0],
      setIsDiscountLoading = _useState4[1];

  var onClickItemHandler = function onClickItemHandler(discount) {
    onSelectDiscount(discount);
  };

  var onClickTnCHandler = function onClickTnCHandler() {
    onClickTnC();
  };

  (0, _react.useEffect)(function () {
    setIsDiscountLoading(isLoading);
  }, [isLoading]);
  /**
   * Map initially selected data into data list
   */

  (0, _react.useEffect)(function () {
    var newData = [];
    data.map(function (disc) {
      disc.isSelected = selectedData.findIndex(function (item) {
        return item.name === disc.name;
      }) >= 0;
      newData.push(disc);
      return disc;
    });
    setDiscounts(function () {
      return [].concat(newData);
    });
  }, [data, selectedData]);
  var shimmerCustomProps = {
    customProperties: {
      className: 'shimmer-row'
    }
  };

  var shimmerLoader = function shimmerLoader() {
    var shimmerBoxes = [];

    for (var i = 0; i < _constant.SHIMMER_COUNT; i++) {
      shimmerBoxes.push( /*#__PURE__*/_react.default.createElement(ShimmerBoxItem, {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "24%"
      }, shimmerCustomProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "80%"
      }, shimmerCustomProps)), /*#__PURE__*/_react.default.createElement(_Shimmer.default, (0, _extends2.default)({
        width: "60%"
      }, shimmerCustomProps))));
    }

    return /*#__PURE__*/_react.default.createElement(ShimmerBoxesWrapper, null, shimmerBoxes);
  };

  var noPromoMessage = function noPromoMessage() {
    return /*#__PURE__*/_react.default.createElement(NoPromoWrapper, null, /*#__PURE__*/_react.default.createElement(NoPromoImage, {
      src: _constant.NO_VOUCHER_IMAGE
    }), /*#__PURE__*/_react.default.createElement(NoPromoTitle, null, labelNoPromoTitle), /*#__PURE__*/_react.default.createElement(NoPromoDescription, null, labelNoPromoDesc));
  };

  var DiscountItems = function DiscountItems() {
    if (discounts.length === 0) return false;
    return /*#__PURE__*/_react.default.createElement(DiscountItemsWrapper, null, discounts.map(function (discProps) {
      return /*#__PURE__*/_react.default.createElement(DiscountItemInnerWrapper, {
        key: discProps.id
      }, /*#__PURE__*/_react.default.createElement(_DiscountItem.default, (0, _extends2.default)({}, discProps, {
        onClickItem: onClickItemHandler,
        onClickTnC: onClickTnCHandler
      })));
    }));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(DiscountListWrapper, null, (isDiscountLoading || discounts.length > 0) && /*#__PURE__*/_react.default.createElement(DiscountListTitle, null, labelSelectPromo), isDiscountLoading && shimmerLoader(), " ", !isDiscountLoading && discounts.length === 0 && noPromoMessage(), !isDiscountLoading && DiscountItems());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

DiscountList.propTypes = _DiscountList.default.PropTypes;
DiscountList.defaultProps = _DiscountList.default.DefaultProps;
var _default = DiscountList;
exports.default = _default;